import {ShapeComponent, shapeComponent} from "set-state-compare/src/shape-component"
import memo from "set-state-compare/src/memo"
import React from "react"
import Route from "@kaspernj/api-maker/build/router/route"
import Switch from "@kaspernj/api-maker/build/router/switch"
import {useWoofRouter} from "shared/woof-router"
export default memo(shapeComponent(class RoutesAdminNotificationTypesRoute extends ShapeComponent {
  setup() {
    this.woofRouter = useWoofRouter()
  }

  render() {
    return (
      <Switch name="notification-types">
        <Route component="edit" exact path="new" />
        <Route component="actions" exact path=":notification_type_id/actions" />
        <Route component="audit-test" exact path=":notification_type_id/audit_test" />
        <Route component="audit-triggers" exact path=":notification_type_id/audit_triggers" />
        <Route component="notifications" exact path=":notification_type_id/notifications" />
        <Route component="edit" exact path=":notification_type_id/edit" />
        <Route component="show" exact path=":notification_type_id" />
        <Route component="index" exact />
        <Route componentPath="fallback" fallback onMatch={this.tt.onFallbackMatch} />
      </Switch>
    )
  }

  onFallbackMatch = () => this.woofRouter.setPageNotFound(true)
}))
